/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} License_Machines_OfflineInputs */



/**
* | output |
* | --- |
* | "Connect to the internet to see the computers using this licence." |
*
* @param {License_Machines_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const license_machines_offline = /** @type {((inputs?: License_Machines_OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<License_Machines_OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connectez-vous à Internet pour voir les ordinateurs qui utilisent cette licence.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stellen Sie eine Internetverbindung her, um die Computer mit dieser Lizenz zu sehen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Connettiti a Internet per vedere i computer che usano questa licenza.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подключитесь к интернету, чтобы увидеть компьютеры с этой лицензией.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Conéctate a Internet para ver los equipos que usan esta licencia.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请连接互联网以查看使用此许可证的电脑。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このライセンスを使用しているコンピューターを表示するには、インターネットに接続してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस लाइसेंस का उपयोग करने वाले कंप्यूटर देखने के लिए इंटरनेट से जुड़ें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ligue-se à Internet para ver os computadores que usam esta licença.")
	return /** @type {LocalizedString} */ ("Connect to the internet to see the computers using this licence.")
});